import { saveModel, loadModel } from '../js/model/Storage';
import { templateMap } from '../js/model/templates';

import VueCookies from 'vue-cookies';

const axios = require('axios');

let apiRoute;
if (process.env.NODE_ENV === 'development') {
  apiRoute = 'http://localhost:8080/api';
} else {
  apiRoute = 'https://api.rebar.ai';
}

/**
 * Vuex Model Actions (Asynchronous)
 */
function serializeModel(state) {
  let savedModel = saveModel(state.model);
  let body = {
    'Label': state.modelTitle,
    'Description': state.modelDescription,
    'Structure': JSON.stringify(savedModel)
  }

  if (state.updateKey) {
    body.UpdateKey = state.updateKey;
  }

  return body;
}


export const actions = {
  loadModel({ dispatch, commit }, modelID) {
    commit('unload');
    axios.get(`${apiRoute}/model/${modelID}`)
      .then((response) => {
        let body = (response.data || {});
        let modelRaw = JSON.parse(body.Structure);
        let model = loadModel(modelRaw);

        commit('setState', {
          modelID: modelID,
          modelTitle: body.Label,
          modelDescription: body.Description,
          model: model,
          isLoaded: false
        });
      })
      .then(() => dispatch('loadData'))
      .then(() => commit('loaded'))
      .catch((e) => console.log(`Error loading model: ${e}`));
  },
  loadTemplate({ dispatch, commit }, templateName) {
    commit('unload');
    let template = templateMap[templateName];

    try {
      commit('setState', {
        modelID: null,
        modelTitle: template.Label,
        modelDescription: template.Description,
        model: template.model,
        isLoaded: false
      });
      dispatch('loadData');
      commit('loaded');
    } catch(e) {
      console.log(`Error loading model: ${e}`);
    }
  },
  updateModel({ state }) {
    let body = serializeModel(state);

    return axios.put(`${apiRoute}/model/${state.modelID}`, body)
      .then(() => {
        VueCookies.remove(`${this.modelID}:update-key`);
        state.updateKey = null;
      })
      .catch((e) => console.log(`Error updating model: ${e}`));
  },
  saveModel({ commit, state }) {
    let body = serializeModel(state);

    return axios.post(`${apiRoute}/model`, body)
      .then((response) => {
        VueCookies.set(
          `${response.data.ID}:update-key`,
          response.data.UpdateKey,
          '1d'
        );

        commit('updateModelID', response.data.ID);

        return state.modelID;
      })
      .catch((e) => console.log(`Error saving model: ${e}`));
  },
  loadData({ state }) {
    return state.model.loadRemoteData();
  }
};